import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const AttendedSectorSchema = () =>
  yup.object({
    iD_Instance: yup.number().label(i18n2._('#Instancia')),
    iD_Course: yup.number().label(i18n2._('#Curso')),
    employee_Nr: yup.number().label(i18n2._('Numero de empleado')),
    name: yup.string().label(i18n2._('Nombre del empleado')),
    sector_Name: yup.string().label(i18n2._('Nombre del sector')),
    cwid: yup.string().label(i18n2._('CWID')),
    name_Course: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .max(80)
      .label(i18n2._('Nombre del Curso')),
    name_Type: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .max(80)
      .label(i18n2._('Tipo')),
    dateVig: yup
      .date()
      .typeError(i18n2._('Ingrese una fecha correcta'))
      .label(i18n2._('Fecha de Vigencia')),
    instructor: yup
      .string()
      .required(i18n2._('Este campo es obligatorio'))
      .max(30)
      .label(i18n2._('Instructor')),
    modality: yup.number().label(i18n2._('Modality')),
  });
